import { FleetAddress, SmsInviteStatus } from '@tmx/data-access';
import { BehaviorSubject } from 'rxjs';

import { AssetVehicle } from './asset-vehicle';
import { LicenseProduct } from './license-product';

export class LicenseUser {
  id: null | number = null;
  entityId = 0;
  externalId: null | string = null;
  email: null | string = null;
  externalName: null | string = null;
  firstName: null | string = null;
  lastName: null | string = null;
  linkedExternalId: null | string = null;
  phoneNumber: null | string = null;
  assignments: LicenseProduct[] = [];
  isSelected = false;
  isInvited = false;
  inviteSent = false;
  inviteCode: null | string = null;
  importStatus: null | string = null;
  copilotVersion: null | string = null;
  mapDataVersion: null | string = null;
  osType: null | string = null;
  osVersion: null | string = null;
  osLogo: null | string = null;
  deviceModel: null | string = null;
  isProductsExpanded$ = new BehaviorSubject(false);
  mapSets: null | string[] = null;
  vehicles: AssetVehicle[] | null = null;
  smsStatus: null | SmsInviteStatus = null;
  address: FleetAddress | null = null;
  lat: null | number = null;
  lon: null | number = null;
  lastStoredTimeStamp: Date | null = null;

  constructor(values: LicenseUser | Record<string, unknown> = {}) {
    Object.assign(this, values);

    const id = values.id;
    this.entityId = typeof id === 'number' ? id : 0;
  }

  get inviteStatus(): null | string {
    // must be handled at user level because Braze event is a userInvite
    if (this.email === null || this.email === '' || !this.assignments.length) {
      return null;
    }
    if (this.isInvited) {
      return 'Re-send';
    }
    return 'Invite';
  }
}
